import React from 'react';
import cls from 'classnames';
import { clsPrefix } from '../const';
import { CnStatisticSecondaryBaseProps } from './types';

/**
 * 指标卡 侧边栏组件
 * @param {*} props
 * @returns
 */
function CnStatisticSecondaryBase({
  children,
  indicators = [],
  divider = false,
  indicatorsLayout,
  keyValueLayout = 'horizontal',
  CnFormat,
  GridList,
}: CnStatisticSecondaryBaseProps) {
  return (
    <div
      className={cls(`${clsPrefix}-secondary`, {
        vertical: keyValueLayout === 'vertical',
        'space-between': keyValueLayout === 'space-between',
      })}
    >
      <GridList
        dataSource={indicators}
        layoutConfig={indicatorsLayout}
        divider={divider}
        renderItem={(item, index) => (
          <span className="cn-format-array-view2" key={index}>
            <span className="cn-format-array-view2-content">
              <CnFormat value={{ text: item.label }} format="CnFormatText" />
              <span className={`${clsPrefix}-secondary-value`}>
                {item.arrowDirection ? (
                  <CnFormat
                    type={`triangle-${item.arrowDirection}-fill`}
                    format="CnFormatIcon"
                    {...{ iconColor: item.arrowColor }}
                  />
                ) : null}
                <CnFormat
                  value={item.value}
                  format="CnFormatNumber"
                  {...{
                    color: item.valueColor,
                    ...(item.valueFormat || null),
                  }}
                />
              </span>
            </span>
          </span>
        )}
      />
      {children}
    </div>
  );
}

export default CnStatisticSecondaryBase;
